export const normalizeMonitorTool = (monitorTool: string) => {
  const re = /[^a-z0-9]/gi
  return monitorTool ? monitorTool.replace(re, '').toLowerCase() : null
}
